<template>
  <div class="flex mb-4 w-full justify-between flex-col bg-beige-academy-200 pt-1
  leading-7">
    <div class="mt-1 flex items-center justify-between w-full py-1
    border-b-2 border-grey-academy-150 px-3">
      <div class="flex flex-col md:flex-row items-start md:items-center">
        <span class="uppercase text-base md:text-lg mr-6 font-bold">
          {{ workExperience.company_name }}</span>
          <div class="flex items-center">
            {{ workExperience.city}}, {{workExperience.country}}
            <span class="flex items-center text-xs md:text-sm md:hidden ml-20
            " v-if="!editing">
        {{ workExperience.pivot.year_start }} {{ getYearEnd }}
      </span>
          </div>
      </div>
      <span class="mt-1 md:flex items-center text-xs md:text-sm hidden" v-if="!editing">
        {{ workExperience.pivot.year_start }} {{ getYearEnd }}
      </span>
      <div v-if="!editing && isLogged" class="flex">
        <button class="hover:text-orange-academy-300" @click="editing = true">
          <edit-icon class="w-3 md:w-4" />
        </button>
        <button class="ml-3 hover:text-orange-academy-300" @click="deleteExperience">
          <bin-icon class="w-1" />
        </button>
      </div>
      <button class="w-auto bg-orange-academy-300 text-white rounded border
        hover:bg-white hover:text-orange-academy-300 border-orange-academy-300 text-sm
        px-2 lg:px-4 py-0 lg:py-1"
        @click="updateExperience" v-if="editing">
          {{$t('stripe.save')}}
      </button>
    </div>
    <div v-if="!editing" class="w-full flex flex-col">
      <span class=" mt-1 uppercase text-base lg:text-lg px-3">
        {{ workExperience.pivot.role }}
      </span>
      <p class="m-2 text-left w-full px-1 pb-2">
        {{ workExperience.pivot.description }}
      </p>
    </div>
    <div v-else class="w-full px-3">
      <div class="flex justify-between items-center mt-3">
        <label for="course" class="w-1/3">{{$t('skills.role')}}:</label>
          <input type="text" id="course" v-model="editedData.role"
          class="border-b-2 w-full p-2 border-grey-academy-150">
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.start-year')}}:</label>
          <input type="text" id="years" v-model="editedData.year_start"
          class="border-b-2 w-full p-2 border-grey-academy-150"
          @keyup="resetErrorField('year_start')">
          <span class="text-red-500"
          v-if="errors.has('year_start')"
          v-text="errors.get('year_start')"
        >
        </span>
      </div>
      <div class="flex justify-between items-center mt-3">
        <label for="years" class="w-1/3">{{$t('skills.end-year')}}:</label>
        <input type="text" id="years" v-model="editedData.year_end" v-if="!stillDoing"
          class="border-b-2 w-5/6 ml-2 p-2 border-grey-academy-150"
          @keyup="resetErrorField('year_end')">
        <input type="text" id="years" v-model="editedData.year_end" disabled v-else
          class="border-b-2 w-5/6 ml-2 p-2 border-grey-academy-150">
        <span class="text-red-500"
          v-if="errors.has('year_end')"
          v-text="errors.get('year_end')"
        >
        </span>
        <div class="flex items-center w-1/5 justify-end">
          <input type="checkbox" id="during" v-model="stillDoing"
          @click="resetErrorField('year_end')">
          <label for="during" class="text-xs md:text-base pl-2">
            {{$t('skills.still')}}</label>
        </div>
      </div>
      <div class="flex flex-col md:flex-row justify-between items-center mt-3 mb-3 md:mb-0">
        <label for="qualification" class="w-full md:w-1/3">{{$t('skills.description')}}</label>
        <textarea type="text" id="qualification" v-model="editedData.description"
        class="border-b-2 w-full p-2 border-grey-academy-150" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Errors from '@/util/Errors';
import { mapGetters } from 'vuex';
import BinIcon from './graphics/BinIcon.vue';
import EditIcon from './graphics/EditIcon.vue';

export default {
  components: { EditIcon, BinIcon },
  props: ['workExperience'],

  data() {
    return {
      editing: false,

      editedData: {
        role: this.workExperience.pivot.role,
        year_start: this.workExperience.pivot.year_start,
        year_end: this.workExperience.pivot.year_end,
        description: this.workExperience.pivot.description,
      },

      stillDoing: !this.workExperience.pivot.year_end,
      errors: new Errors(),
    };
  },

  watch: {
    stillDoing() {
      if (this.stillDoing) {
        this.editedData.year_end = null;
      }
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    isLogged() {
      if (this.user && this.user.teacher
      && this.user.teacher.id === this.workExperience.pivot.teacher_id) {
        return true;
      }
      return false;
    },

    getYearEnd() {
      if (this.workExperience.pivot.year_end) {
        return `- ${this.workExperience.pivot.year_end}`;
      }
      if (!this.workExperience.pivot.year_end && !this.workExperience.pivot.year_start) {
        return null;
      }
      return `- ${this.$t('skills.now')}`;
    },
  },

  methods: {
    resetErrorField(field) {
      this.errors.clear(field);
    },
    updateExperience() {
      axios.put(`/api/teachers/${this.workExperience.pivot.teacher_id}/work-experiences/
      ${this.workExperience.id}`, this.editedData).then(() => {
        this.$emit('updated');
        this.editing = false;
      }).catch(({ response: { data: { errors } } }) => {
        this.errors.record(errors);
      });
    },

    deleteExperience() {
      axios.delete(`/api/teachers/${this.workExperience.pivot.teacher_id}/work-experiences/
      ${this.workExperience.id}`).then(() => {
        this.$emit('updated');
        this.editing = false;
      });
    },
  },
};
</script>
